import { resolveApiUrl } from "./runtimeConfig";

// API URL: runtime config.js, then build-time REACT_APP_API, then the dev default
export const linkApi = resolveApiUrl();

export const QUARTER_LENGTH = 26; //  27 Quarters therefore max is 27

export const SCREEN_DEFAULT = {
  1: "/dashboard",
  2: "/survey_urls",
  3: "/raw_data",
  4: "/documents",
  6: "/exportData",
  7: "/user_management",
  8: "/monitoring",
  9: "/area-management",
  10: "/data-import",
  11: "/hospital-directory",
};

export const screenReverst = {
  dashboard: 1,
  survey_urls: 2,
  raw_data: 3,
  documents: 4,
  user_management: 5,
  monitoring: 6,
  "area-management": 7,
  "data-import": 8,
  "hospital-directory": 9,
};
